module.exports = __webpack_public_path__ + "img/Camera_Filled_24px_Icon.60e99f92.svg";